module.exports = __webpack_public_path__ + "img/masked_enfermagem.18d664e4.svg";